import { render, staticRenderFns } from "./TmCard.vue?vue&type=template&id=5a6605cb&scoped=true&"
import script from "./TmCard.vue?vue&type=script&lang=js&"
export * from "./TmCard.vue?vue&type=script&lang=js&"
import style0 from "./TmCard.vue?vue&type=style&index=0&id=5a6605cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6605cb",
  null
  
)

export default component.exports